export enum ArenaCartItemState {
    Available = 1,
    Busy = 2
}